import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StoryList from 'components_library/templates/StoryList/StoryListWebWrapper';
import IFrame from 'components_library/atoms/IFrame/IFrame';
import LinksList from 'components_v2/desktop/LinksList';
import Text from 'components_library/atoms/Text';
import BreadCrumb from 'components_v2/common/BreadCrumb/BreadCrumb';
import AtfContent from 'components_library/molecules/AtfContent/AtfContent';
import VideoLayout from 'components_library/organisms/VideoLayoutV2';
import InViewObserver from 'components/InViewObserver';
import Morebtn from 'components_v2/desktop/Morebtn';
import analyticsWrapper from 'components_library/utils/analyticsWrapper';
import { getSchemaStyles } from 'components_library/utils/getStyleObject';
import { setPageConfigAndSendIBeatCall } from 'utils/iBeatConfig';
import AdCaller from 'helpers/ads/adCaller';
import Banner from 'components_library/molecules/Banner/Banner';
import AffiliatesContentV2 from 'components/AffiliatesContentV2/AffiliatesContentV2';
import CapsuleNew from 'components_v2/common/CapsuleNew';
import PointsTableWrapper from '../../../newslisting/components/common/PointsTableWrapper/PointsTableWrapper';
import MatchCardInfoSlider from '../../../../components_v2/common/MatchCardInfoSlider/MatchCardInfoSlider';
import Newsletter from '../../../../components_v2/common/Newsletter/Newsletter';
import s from './Landing.scss';
import FaqData from '../../../games/components/common/Faq/Faq';

// import ErrorBoundary from '../../../../components/ErrorBoundary/ErrorBoundary';
// import ElectionWidgetMainWrapper from '../../../../components/ElectionV2/ElectionWidgetMainWrapper/ElectionWidgetMainWrapper';

const Landing = props => {
  const breadCrumbData =
    props.navigation && props.navigation.breadcrumbs
      ? props.navigation.breadcrumbs
      : [];

  const l2Nav =
    props.navigation && props.navigation.l2 && props.navigation.l2
      ? props.navigation.l2
      : [];

  const processNewsLetter = () => {
    let newletterPos;
    const newsLetterItems = props.newsData?.sections?.filter(
      (component, index) => {
        if (component.tn === 'newsletterbanner') {
          newletterPos = index;
        }
        return component.tn === 'newsletterbanner';
      },
    );
    if (
      newsLetterItems &&
      Array.isArray(newsLetterItems) &&
      newsLetterItems.length > 0
    ) {
      const newsLetterData = {
        tn: 'newsletterbanners',
        items: newsLetterItems,
      };
      props.newsData.sections = props.newsData?.sections?.filter(
        component => component.tn !== 'newsletterbanner',
      );
      if (
        props.newsData &&
        props.newsData.sections &&
        Array.isArray(props.newsData.sections)
      ) {
        props.newsData.sections.splice(newletterPos, 0, newsLetterData);
      }
    }
  };
  processNewsLetter();
  useEffect(() => {
    setPageConfigAndSendIBeatCall();
  }, []);

  const onVideoClick = (gaType, data, index) => {
    if (gaType) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: gaType,
        category: 'story_click',
        label: data?.wu,
        story_no: index,
        msid: data?.id,
      });
    }
  };

  const renderComponent = componentData => {
    let items;
    let adComponent;
    let typeShemaClassNames;
    switch (componentData.type || componentData.tn) {
      case 'cricketcardList':
        items =
          componentData?.data?.sectionitems &&
          Array.isArray(componentData?.data?.sectionitems) &&
          componentData?.data?.sectionitems.length > 0 &&
          componentData?.data?.sectionitems[0]?.items &&
          Array.isArray(componentData?.data?.sectionitems[0]?.items)
            ? componentData?.data?.sectionitems[0]?.items
            : [];
        return (
          <div className={s.landingscorecard}>
            <MatchCardInfoSlider
              items={items}
              isLanding
              slideToShow={2.8}
              // seriesname={componentData.heading}
            />
          </div>
        );
      case 'story_list':
        items = Array.isArray(componentData.data)
          ? componentData.data
          : componentData?.data?.items;
        return (
          <StoryList
            items={items}
            {...componentData}
            location={props.location}
          />
        );
      case 'iframe':
        return (
          <IFrame {...componentData?.config} key={componentData?.config?.tn} />
        );
      case 'keywords':
        return (
          <LinksList
            sectionData={{
              name: componentData?.config?.name,
              items: componentData.data?.items
                ? componentData.data?.items
                : componentData.data,
              ga4category: componentData?.gaType,
            }}
            key={componentData.id}
          />
        );
      case 'ad':
        if (!(componentData && componentData?.config)) {
          return null;
        }

        adComponent = (
          <AdCaller
            data={componentData?.config}
            isCTN={
              componentData?.config.adType &&
              componentData?.config.adType === 'ctn'
            }
          />
        );
        typeShemaClassNames = getSchemaStyles(
          componentData?.config.spacing,
          false,
        );

        if (componentData?.config && componentData.config.placeholderType) {
          if (componentData.config.placeholderType === 'leaderboard') {
            return (
              <div
                className={`${typeShemaClassNames} ${
                  componentData.config.placeholderType
                }_placeHolder`}
              >
                <div className="lbAd">{adComponent}</div>
              </div>
            );
          }
          return (
            <div
              className={`${typeShemaClassNames} paisa-wrapper ${
                componentData.config.placeholderType
              }_placeHolder`}
            >
              {adComponent}
            </div>
          );
        }
        return adComponent;
      case 'videos_section':
        if (
          componentData &&
          Array.isArray(componentData.data) &&
          componentData.data.length > 0
        ) {
          return (
            <InViewObserver
              inViewCallback={() => {
                analyticsWrapper('ga4', {
                  event: 'user_shown',
                  type: componentData.gaType,
                  label: window && window?.location?.href,
                });
              }}
            >
              <VideoLayout
                key={componentData.id}
                sectionData={componentData}
                gaFunction={(data, index) => {
                  onVideoClick(componentData.gaType, data, index);
                }}
                isVideoSkipAds={componentData && componentData.skipAds}
              />
            </InViewObserver>
          );
        }
        return null;
      case 'btfcontent':
        if (
          !(
            componentData &&
            Array.isArray(componentData.data) &&
            componentData.data[0] &&
            componentData.data[0].seodescription
          )
        ) {
          return null;
        }
        return (
          <Text
            text={componentData.data[0].seodescription}
            className={componentData.config && componentData.config.className}
            btfId="btf-content"
            background="listing_v2"
            isdangerouslySetInnerHTML
          />
        );
      case 'faq': {
        const faqData = componentData?.data?.[0]?.faqData;
        const mainEntities = faqData?.mainEntity;

        if (!Array.isArray(mainEntities)) {
          return null;
        }

        const mainData = mainEntities.map(item => ({
          hl: item?.name || '',
          des: item?.acceptedAnswer?.text || '',
        }));
        return <FaqData data={mainData} handleFaqLayout />;
      }

      case 'atfcontent':
        if (
          !(
            componentData &&
            Array.isArray(componentData.data) &&
            componentData.data[0] &&
            componentData.data[0].strsyn
          )
        ) {
          return null;
        }
        return <AtfContent content={componentData.data[0].strsyn} />;
      // case 'election': {
      //   return (
      //     componentData &&
      //     componentData?.tabs && (
      //       <ErrorBoundary>
      //         <InViewObserver
      //           inViewCallback={() => {
      //             analyticsWrapper('ga4', {
      //               event: 'user_shown',
      //               type: `exitpoll_widget`,
      //             });
      //           }}
      //         >
      //           <ElectionWidgetMainWrapper
      //             isHomePage
      //             isWapView={false}
      //             tabs={componentData?.tabs}
      //             hideETheading
      //             hideLiveblog
      //             inpageminitvoff
      //           />
      //         </InViewObserver>
      //       </ErrorBoundary>
      //     )
      //   );
      // }
      case 'newsletterbanners':
        if (componentData) {
          return <Newsletter {...componentData} isListingPage />;
        }
        return null;
      case 'points_table': {
        return (
          componentData &&
          componentData.path && (
            <PointsTableWrapper
              sectionItem={componentData}
              gaCategory={componentData.gaType}
            />
          )
        );
      }
      case 'banner': {
        return (
          <div className={s.banner_spacing}>
            <Banner data={componentData} Url={props.Url} />
          </div>
        );
      }
      case 'affiliateWidget': {
        const {
          jarvisConfig = {},
          componentProps = {},
          enableWidgetsOnLoad,
        } = componentData;
        return (
          <div className={s.banner_spacing}>
            <AffiliatesContentV2
              {...jarvisConfig}
              componentProps={componentProps}
              showWidgetOnPrimeToo
              enableWidgetsOnLoad={enableWidgetsOnLoad}
            />
          </div>
        );
      }
      default:
        return null;
    }
  };

  return (
    <div data-translate-id="cw" data-translate-page="1">
      <BreadCrumb data={breadCrumbData} wrapperClass="breadcrumb" />
      {props.seoData &&
        props.seoData.hl &&
        (props.seoData.msid === '104313430' ? (
          <div className={`${s.h1LinkWrapper} ${s.linkWithButton}`}>
            <div className={`${s.heading_fuelWidget}`}>
              <h1 className={s.h1tag}>{props.seoData.hl.replace(/-/g, ' ')}</h1>
            </div>
            <Morebtn
              moreText="Share Scam Story"
              moreLink="/business/dontgetscammed/share-your-scam-story"
              // fullWidth
              redbg
              smallSize
            />
          </div>
        ) : (
          <div className={`${s.heading_fuelWidget}`}>
            <h1 className={s.h1tag}>{props.seoData.hl.replace(/-/g, ' ')}</h1>
          </div>
        ))}
      {props.seoData.msid === '104313430' && (
        <div className={`${s.headerStickyTab} ${s.headerStickyV2}`}>
          <ul id="zodiaclist" data-testid="zodiac-list">
            {l2Nav.map(
              item =>
                props.location !== item.link && (
                  <li key={item.hl}>
                    <CapsuleNew
                      item={{ hl: item.label, wu: item.link }}
                      prefixRequired={false}
                      // sunsignName={}
                      // isRedStyle
                      isSmallSticky
                      id={item.hl}
                    />
                  </li>
                ),
            )}
          </ul>
        </div>
      )}

      {props.newsData &&
        props.newsData.sections &&
        props.newsData.sections.map(component => renderComponent(component))}
    </div>
  );
};

const mapStateToProps = state => ({
  navigation: state.header.data && state.header.data.navigation,
  Url: state.url,
});

Landing.propTypes = {
  newsData: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  navigation: PropTypes.shape({
    breadcrumbs: '',
  }),
};

Landing.defaultProps = {
  newsData: {
    sections: [],
  },
  navigation: {},
};

export default connect(mapStateToProps)(Landing);
